/**
 @ngdoc service
 @name mapScreeningsubcheckTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapScreeningsubcheckTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);


            tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('candidateName','candidateURI'));
            tileFactory.addFieldToColumn2(tileFactory.field.newField('owner'));
            tileFactory.addFieldToColumn2(tileFactory.field.newField('requester'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('requiredBy'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('attributeType'));
            tileFactory.addStatus(tileFactory.status.newStatus('screeningSubcheckStatus',
                // Positives
                [
                    tileFactory.LOOKUP_VALUE.SCREENING_SUBCHECK_COMPLETE_PASS,
                    tileFactory.LOOKUP_VALUE.SCREENING_SUBCHECK_COMPLETE_DISC
                ],
                // Negatives
                [
                    tileFactory.LOOKUP_VALUE.SCREENING_SUBCHECK_COMPLETE_FAIL
                 ],
                // Warnings
                [
                    tileFactory.LOOKUP_VALUE.SCREENING_SUBCHECK_INPROGRESS
                ]

            ));
            return tileFactory.tileData;
        };

        return {
            map : map
        };
    };

    mapScreeningsubcheckTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapScreeningsubcheckTileService', mapScreeningsubcheckTileService);

}());